
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[studyProgram]",
      function () {
        return require("private-next-pages/[studyProgram]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[studyProgram]"])
      });
    }
  